import classNames from 'classnames';
import Image from '@picsart/image/Image';

import usePreviewModal from '../usePreviewModal';
import useStyles from '../styles';

interface IPreviewModalImage {
    imageSrc: string;
    className?: string;
}

const PreviewModalImage = ({ imageSrc, className }: IPreviewModalImage) => {
  const classes = useStyles();
  const { onImageLoad, imageRef, isImageLoaded } = usePreviewModal();

  return (
    <Image
      ref={imageRef}
      src={imageSrc}
      onLoad={onImageLoad}
      className={classNames(classes.image, className, { [classes.loadedImage]: isImageLoaded })}
    />
  );
};

export default PreviewModalImage;
